import React from 'react';
import Style from '../../assets/style.scss';
import { BCCard, BCCol, BCRow, BCTag, findMessage } from '@bimser/components';
import dayjs from 'dayjs';
import classNames from 'classnames/bind';
const cx = classNames.bind(Style);

interface ILicenceInfo {
	status: boolean;
	version: string;
	type: string;
	productPackage: string;
	startDate: string;
	endDate: string;
	modules: Array<string>;
	properties: Array<string>;
	userCount: number;
	userLimit: number;
	projectCount: number;
	projectLimit: number;
	cpuCount: number;
	cpuLimit: number;
}
const defaultLicenceInfo = {
	status: false,
	version: null,
	type: null,
	productPackage: null,
	startDate: null,
	endDate: null,
	modules: [],
	properties: [],
	userCount: 0,
	userLimit: 0,
	projectCount: 0,
	projectLimit: 0,
	cpuCount: 0,
	cpuLimit: 0
};

const LicenceInfo = props => {
	const getLicenceInfo = () => {
		return (
			<BCRow gutter={[24, 4]}>
				<BCCol
					xs={24}
					sm={12}
					className={[Style.marginTop8, Style.fontWeightBoldTitle].join(' ')}
				>
					{findMessage.get('103327')}
				</BCCol>
				<BCCol
					xs={24}
					sm={12}
					className={[Style.marginTop8, Style.fontWeightBoldTitle].join(' ')}
				>
					{findMessage.get('100677')}
				</BCCol>
				<BCCol
					xs={24}
					sm={12}
				>
					<span className={cx({ circleGreen: props.status, circleRed: !props.status })} />
					{props.status ? findMessage.get('100392') : findMessage.get('101256')}
				</BCCol>
				<BCCol
					xs={24}
					sm={12}
				>
					{props.version || '-'}
				</BCCol>
				<BCCol
					xs={24}
					sm={12}
					className={[Style.marginTop, Style.fontWeightBoldTitle].join(' ')}
				>
					{findMessage.get('103328')}
				</BCCol>
				<BCCol
					xs={24}
					sm={12}
					className={[Style.marginTop, Style.fontWeightBoldTitle].join(' ')}
				>
					{findMessage.get('103329')}
				</BCCol>
				<BCCol
					xs={24}
					sm={12}
				>
					{props.type || '-'}
				</BCCol>
				<BCCol
					xs={24}
					sm={12}
				>
					{props.productPackage || '-'}
				</BCCol>
				<BCCol
					xs={24}
					className={[Style.marginTop, Style.fontWeightBoldTitle].join(' ')}
				>
					{`${findMessage.get('103330')} ${findMessage.get('100995')} / ${findMessage.get(
						'100996'
					)}`}
				</BCCol>
				<BCCol xs={24}>{`${getDate(props.startDate)} / ${getDate(props.endDate)}`}</BCCol>
			</BCRow>
		);
	};

	const getDate = date => {
		if (date && dayjs(date).isValid()) return dayjs(date).format('L');
		return '-';
	};

	const getModuls = () => {
		return (
			<>
				<p className={[Style.marginTop8, Style.fontWeightBoldTitle].join(' ')}>
					{findMessage.get('103331')}
				</p>
				{props.modules.length ? (
					props.modules.map(
						(t, i) =>
							t && (
								<BCTag
									key={i}
									text={t.toString()}
									className={Style.marginBottom5}
								/>
							)
					)
				) : (
					<p>{findMessage.get('103323')}</p>
				)}
			</>
		);
	};

	const getProperties = () => {
		return (
			<>
				<p className={[Style.marginTop8, Style.fontWeightBoldTitle].join(' ')}>
					{findMessage.get('101206')}
				</p>
				{props.properties.length ? (
					props.properties.map(
						(t, i) =>
							t && (
								<BCTag
									key={i}
									text={t.toString()}
									className={Style.marginBottom5}
								/>
							)
					)
				) : (
					<p>{findMessage.get('103322')}</p>
				)}
			</>
		);
	};

	const getLimitInfo = () => {
		return (
			<>
				<BCRow gutter={[24, 4]}>
					<BCCol
						span={12}
						className={[Style.marginTop8, Style.fontWeightBoldTitle].join(' ')}
					>
						{findMessage.get('103310')}
					</BCCol>
					<BCCol
						span={12}
						className={Style.fontWeightBoldTitle}
					>
						{`${findMessage.get('103311')} / ${findMessage.get('101854')}`}
					</BCCol>
					<BCCol span={12}>{findMessage.get('100728')}</BCCol>
					<BCCol span={12}>{`${props.userCount} / ${props.userLimit}`}</BCCol>
					<BCCol span={12}>{findMessage.get('103312')}</BCCol>
					<BCCol span={12}>{`${props.projectCount} / ${props.projectLimit}`}</BCCol>
					<BCCol span={12}>{'CPU'}</BCCol>
					<BCCol span={12}>{`${props.cpuCount} / ${props.cpuLimit}`}</BCCol>
				</BCRow>
			</>
		);
	};
	return (
		<BCCard
			bordered={false}
			className={Style.licenceInfoContainer}
			seleniumId={'licenceInfoCard'}
		>
			<div
				data-selenium-id={'licenceInfo'}
				className={Style.licenceInfoContainer}
			>
				<BCRow
					gutter={[16, 16]}
					style={{ margin: 'auto' }}
				>
					<BCCol
						span={12}
						md={6}
						className={Style.rigthBorder}
					>
						{getLicenceInfo()}
					</BCCol>
					<BCCol
						span={12}
						md={6}
						className={Style.rigthBorder}
					>
						{getModuls()}
					</BCCol>
					<BCCol
						span={12}
						md={6}
						className={Style.rigthBorder}
					>
						{getProperties()}
					</BCCol>
					<BCCol
						span={12}
						md={6}
					>
						{getLimitInfo()}
					</BCCol>
				</BCRow>
			</div>
		</BCCard>
	);
};

export { LicenceInfo as default, ILicenceInfo, defaultLicenceInfo };
